import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";
import ActivityChoiceIndicator from "@/components/ActivityChoiceIndicator";
import ChevronRightIcon from "@/icons/ChevronRightIcon";
import {
  rootCss,
  containerCss,
  headingCss,
  headingTextCss,
  iconCss,
  responseTextCss,
} from "./QuizResponseItem.style";

const propTypes = {
  buttonEventProperties: PropTypes.object,
  correctAnswer: PropTypes.string,
  handleClick: PropTypes.func,
  selectedAnswer: PropTypes.string,
  shouldHideQuizAnswers: PropTypes.bool,
  position: PropTypes.number,
};

const ButtonWithTrackEvent = withTrackEvent(Button);

const QuizResponseItem = ({
  buttonEventProperties,
  correctAnswer,
  handleClick,
  position,
  selectedAnswer,
  shouldHideQuizAnswers,
}) => {
  const isCorrect = correctAnswer === selectedAnswer;

  const renderCopy = () => {
    if (isCorrect) {
      return `You chose ${selectedAnswer}, the correct answer.`;
    } else {
      const correctAnswerCopy = !shouldHideQuizAnswers
        ? `The correct answer is ${correctAnswer}. `
        : "";
      return `${correctAnswerCopy}You chose ${selectedAnswer}.`;
    }
  };

  return (
    <ButtonWithTrackEvent
      {...buttonEventProperties}
      flavor={Button.flavors.incognito}
      __cssFor={{ root: rootCss }}
      onClick={() => handleClick()}
    >
      <div css={containerCss}>
        <div>
          <div css={headingCss}>
            <span css={headingTextCss}>Question {position}</span>
            <ActivityChoiceIndicator
              labelColor={isCorrect ? "success" : "danger"}
              status={isCorrect ? "correct" : "incorrect"}
              text={isCorrect ? "correct" : "incorrect"}
            />
          </div>
          <p css={responseTextCss}>{renderCopy()}</p>
        </div>
        <ChevronRightIcon css={iconCss} />
      </div>
    </ButtonWithTrackEvent>
  );
};

QuizResponseItem.propTypes = propTypes;

export default QuizResponseItem;
